module.exports = __webpack_public_path__ + "static/card-project5-516bb2deab2bbc387e6d4606f4adfef5.jpg";